// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"if_a bhe_ji","CommentListPlaceholder--Legacy":"if_b bhe_ra bhe_wo"};